import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <footer style={{ background: '#1a1a2e' }} className="text-gray-400 mt-auto">
            <div className="max-w-7xl mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    <div className="md:col-span-2">
                        <div className="mb-3">
                            <img src="/logo.png" alt="SellerSource" style={{ width: '62px', height: '62px', objectFit: 'contain' }} />
                        </div>
                        <p className="text-sm leading-relaxed max-w-xs">
                            AI-powered retail arbitrage intelligence. Discover profitable opportunities and grow your Amazon business with data-driven reports.
                        </p>
                    </div>
                    <div>
                        <h6 className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-4">Product</h6>
                        <div className="space-y-2">
                            <Link to="/" className="block text-sm hover:text-white transition-colors">Home</Link>
                            <Link to="/pricing" className="block text-sm hover:text-white transition-colors">Pricing</Link>
                            <Link to="/register" className="block text-sm hover:text-white transition-colors">Sign Up</Link>
                            <Link to="/dashboard" className="block text-sm hover:text-white transition-colors">Dashboard</Link>
                        </div>
                    </div>
                    <div>
                        <h6 className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-4">Account</h6>
                        <div className="space-y-2">
                            <Link to="/login" className="block text-sm hover:text-white transition-colors">Login</Link>
                            <Link to="/reports" className="block text-sm hover:text-white transition-colors">My Reports</Link>
                            <Link to="/billing" className="block text-sm hover:text-white transition-colors">Billing</Link>
                        </div>
                    </div>
                </div>
                <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between text-xs text-gray-600">
                    <span>&copy; {new Date().getFullYear()} Seller Source. All rights reserved.</span>
                    <span className="mt-2 md:mt-0">Powered by AI · Secure payments by Stripe</span>
                </div>
            </div>
        </footer>
    );
}
